import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import api from "../../api";
import settings from "../../settings";
import Activities from "./Activities";
import { getErrorMessage } from "../messages/errorMessages";
import {getErrorNode} from "../../utils/errorUtil";

class TodayResultsAndReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityNode: null,
    };
  }

  componentDidMount() {
    this.isCompMounted = true;
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  componentWillUnmount() {
    this.isCompMounted = false;
  }

  isCompMounted = false;

  loadData = (props) => {
    const params = {
      view: "activities",
      pickedUser: props.pickedUser,
      days: 0,
      month: new Date().getMonth() + 1,
      sserver: settings.appName,
      userID: props.user.userid,
      sessionID: localStorage.getItem("sessionID"),
    };

    api.lp.getActivitiesView(params).then((res) => {
      parseString(res.data, { async: false }, (err, result) => {
        if(result == null) {
            const errorNode = getErrorNode();
            if (this.isCompMounted) this.setState({ activityNode: errorNode });
            return;
        }
        const root = Object.keys(result)[0];
        if (root === "errors") {
          if (_.get(result, `${root}.error[0].$.errType`) === "unauthorized") {
            localStorage.errorMessage = _.get(
              result,
              `${root}.error[0].errMsg[0]`,
              ""
            );
            const errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            this.props.expireSession(errorMessage);
          }
        } else {
          const activityNode = (
            <Activities
              key={`activities_today`}
              {...this.props}
              data={result.activities}
              days={0}
            />
          );
          if (this.isCompMounted) this.setState({ activityNode });
        }
      });
    });
  };

  render() {
    const { activityNode } = this.state;
    if (activityNode === null) {
      return (
        <Segment
          loading
          className="activity-loading table-no-border box-shadow-none"
        >
          {""}
        </Segment>
      );
    }
    return this.state.activityNode;
  }
}

export default TodayResultsAndReports;



// WEBPACK FOOTER //
// ./src/components/myaccount/TodayResultsAndReports.js